import { SidebarSection } from './sidebarUtils'
import HomeIcon from '@mui/icons-material/Home'
import HiveIcon from '@mui/icons-material/Hive'
import AttributionIcon from '@mui/icons-material/Attribution'
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import { SidebarSectionDefinition } from '../../store/types/components/sidebar/sidebarTypes'

export const SIDEBAR_SECTION_DEFINITIONS: SidebarSectionDefinition[] = [
  {
    key: SidebarSection.MAIN,
    icon: HomeIcon,
    labelKey: 'components.sidebar.divider.mainMenu',
    ariaLabelOpenKey: 'components.sidebar.divider.sectionMainMenuOpen',
    ariaLabelCloseKey: 'components.sidebar.divider.sectionMainMenuClose',
  },
  {
    key: SidebarSection.PROJECTS,
    icon: HiveIcon,
    labelKey: 'components.sidebar.divider.projects',
    ariaLabelOpenKey: 'components.sidebar.divider.sectionProjectsOpen',
    ariaLabelCloseKey: 'components.sidebar.divider.sectionProjectsClose',
    centerContentWhenCollapsed: true,
    disableToggleWhenSidebarCollapsed: true,
  },
  {
    key: SidebarSection.RESOURCING,
    icon: AttributionIcon,
    labelKey: 'components.sidebar.divider.resourcing',
    ariaLabelOpenKey: 'components.sidebar.divider.sectionResourcingOpen',
    ariaLabelCloseKey: 'components.sidebar.divider.sectionResourcingClose',
    centerContentWhenCollapsed: true,
    disableToggleWhenSidebarCollapsed: true,
  },
  {
    key: SidebarSection.RECRUITMENT,
    icon: BusinessCenterIcon,
    labelKey: 'components.sidebar.divider.recruitment',
    ariaLabelOpenKey: 'components.sidebar.divider.sectionRecruitmentOpen',
    ariaLabelCloseKey: 'components.sidebar.divider.sectionRecruitmentClose',
  },
  {
    key: SidebarSection.ADMINISTRATION,
    icon: AdminPanelSettingsIcon,
    labelKey: 'components.sidebar.divider.administration',
    ariaLabelOpenKey: 'components.sidebar.divider.sectionAdministrationOpen',
    ariaLabelCloseKey: 'components.sidebar.divider.sectionAdministrationClose',
  },
  {
    key: SidebarSection.PERSONAL,
    icon: AccountCircleIcon,
    labelKey: 'components.sidebar.divider.personal',
    ariaLabelOpenKey: 'components.sidebar.divider.sectionPersonalOpen',
    ariaLabelCloseKey: 'components.sidebar.divider.sectionPersonalClose',
  },
]
